import cognitoAuth from '../../utils/cognitoAuth.mjs';
import toResponse from './toRes.mjs';
import salesforceConfig from '../../utils/salesforceConfig.mjs';

const getAccounts = async(query, uuid) => {
  const token = await cognitoAuth();
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }

  const body = JSON.stringify({
    command: 'SalesforceAccountSearch',
    uuid,
    companyName: query,
  });

  const response = await fetch(salesforceConfig().salesforceUrl, { method: 'POST', headers, body })
  const res = await response.json();

  return toResponse(res.accounts);

}

export default getAccounts;